import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const LicenceEdit = lazy(() => import('./licences/Edit'))
const MedicalCertificateEdit = lazy(() => import('./medical-certificates/Edit'))
const CrewTravelDocumentEdit = lazy(() => import('./travel-documents/Edit'))

export const TrainingUserRecordsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--training--user-records']}>
    <Route index element={<Index />} />
    <Route path='licences/new' element={<LicenceEdit />} />
    <Route path='licences/:id' element={<LicenceEdit />} />
    <Route path='medical-certificates/new' element={<MedicalCertificateEdit />} />
    <Route path='medical-certificates/:id' element={<MedicalCertificateEdit />} />
    <Route path='travel-documents/new' element={<CrewTravelDocumentEdit />} />
    <Route path='travel-documents/:id' element={<CrewTravelDocumentEdit />} />
  </SubRouter>
))
